export let productCenterGaiAViewEN = {
  h1: "PDGaiA",
  h2: ": The Grand Premiere",
  h3: "Simulation-based Testing and Development Platform for Automated Driving",
  // gaiAModule2: [
  //   "World-leading full-physical environmental perception sensor model",
  //   "Sensor simulation with high validity",
  //   "The sensor model can simulate the visualization effect of different scenes, restore the reflection characteristics of millimeter wave and laser in high fidelity",
  //   "simulate detailed physical phenomena and dynamic sensor performance",
  // ],
  gaiAModule2Title:
    "World-leading Full-physical Environmental Perception Sensor Model Sensor Simulation with High Validity",
  gaiAModule2Subtitle:
    "The sensor model accurately simulates visualization effects across scenarios, precisely replicates millimeter-wave/laser reflection characteristics, and simulates detailed phenomena of physical optics and dynamic sensor performance.",
  // gaiAModule3: [
  //   "Powerful scene construction ability all-round environment interactive experience",
  //   "It supports various types of environment simulation, and can build high-fidelity static environment, intelligent dynamic ",
  //   "environment, high-restoration weather environment and diversified scene library to achieve full coverage of driving scenarios.",
  // ],
  gaiAModule3Title:
    "Powerful Scenarios Construction Capability, Comprehensive Environmental Interaction Experience",
  gaiAModule3Subtitle:
    "Supports multiple types of environmental simulation, enabling the construction of high-fidelity static environments, intelligent dynamic environments, and weather conditions, along with diverse scenario libraries, facing full coverage of driving scenarios.",
  gaiAModule4: {
    toolsMoudule:
      "Abundant Tool Modules Enabling Convenient Whole-loop Simulation",
    toolsMoudule1: {
      h1: "Test Automation",
      h2: "Load and run pre-set test environment, record specific events and replay them to realize unmanned and fully automated testing and iteration.",
    },
    toolsMoudule2: {
      h1: "Import Real Scenario Data",
      h2: "The testcases from the real scenarios library can be imported into the simulation platform and generate virtual scenarios.",
    },
    toolsMoudule3: {
      h1: "Flexible Interfaces and Programming Languages",
      h2: "With multiple programmable interfaces, supporting various communication modes and multiple programming languages.",
    },
  },
  gaiAModule5: {
    serviceModel: "Cloud Simulation Service Mode",
    serviceModel1: {
      h1: "Independent Tool Mode",
      h2: "We provide customers with cloud-based testing scenarios",
      h3: "Customers use independent tools to access data on the cloud and perform tests locally",
    },
    serviceModel12: {
      h1: "Cloud Computing Center",
      h2: "We provide computing and data storage services on the cloud",
      h3: "Customers perform parallel computing and algorithm verification and verification tests on the cloud.",
    },
  },
  gaiAModule6: {
    sass: "Cloud Simulation Workflow",
    sassImg: require("@/static/img/productmodule6_en.webp"),
  },
};
export let productCenterGaiAViewCN = {
  h1: "PDGaiA",
  h2: "重磅亮相！",
  h3: "沛岱汽车 自动驾驶精准在环仿真测试平台",
  // gaiAModule2: [
  //   "全球领先的物理级环境感知传感器模型",
  //   "实现超高逼真度的传感器仿真",
  //   "传感器模型能够模拟不同场景的可视化效果，高保真还原毫米波",
  //   "和激光的反射特性，仿真细致的物理现象和动态传感器性能等",
  // ],
  gaiAModule2Title:
    "全球领先的物理级环境感知传感器模型\n实现超高逼真度的传感器仿真",
  gaiAModule2Subtitle:
    "传感器模型精准模拟跨场景的可视化效果，精确还原毫米波和激光反射特性，仿真细致的物理现象和动态传感器性能等。",
  gaiAModule3: [
    "强大的场景构建能力 全方位环境交互体验",
    "支持多种类型环境模拟，能够构建高保真的静态环境、智能化的动态环",
    "境、高还原度的天气环境及多样化的场景库，实现驾驶场景全覆盖。",
  ],
  gaiAModule3Title: "强大的场景构建能力 全方位环境交互体验",
  gaiAModule3Subtitle:
    "支持多种类型环境模拟，能够构建高保真的静态环境、智能化的动态环境、高还原度的天气环境及多样化的场景库，实现驾驶场景全覆盖。",
  gaiAModule4: {
    toolsMoudule: "丰富的工具模块，实现全环路便捷仿真",
    toolsMoudule1: {
      h1: "自动化测试",
      h2: "对已设置的测试环境进行加载运行，记录特定事件并回放，真正实现无人化全自动测试",
    },
    toolsMoudule2: {
      h1: "真实场景数据导入",
      h2: "真实场景库的testcase可导入到仿真平台并生成虚拟场景",
    },
    toolsMoudule3: {
      h1: "灵活的接口与编程语言",
      h2: "拥有多个可编程接口，支持多种通讯模式及多种编程语言",
    },
  },
  gaiAModule5: {
    serviceModel: "云端仿真服务模式",
    serviceModel1: {
      h1: "独立工具模式",
      h2: "我们向客户提供云上的测试场景",
      h3: "客户使用独立工具访问云上的数据并在本地执行测试",
    },
    serviceModel12: {
      h1: "云计算中心",
      h2: "我们在云上提供计算和数据存储",
      h3: "客户使用云来执行并行计算和算法验证测试",
    },
  },
  gaiAModule6: {
    sass: "云端仿真流程图",
    sassImg: require("@/static/img/productmodule6.png"),
  },
};
